import request from "../request";

export default {
  // 列表
  getCategory(data) {
    return request.get("/content/getCategory", data);
  },
  
  getConfig(data) {
    return request.get("/content/getConfig", data);
  },


};
